module.exports = __webpack_public_path__ + "static/approach-5f046eea116264ee20089b2aef7a2881.png";